module.exports = __webpack_public_path__ + "img/icon_submenu20.de270d19.svg";